<template>
  <div class="services-details-bg pt-120 pb-100">
    <div class="container">
      <!-- Responsive, right-aligned image row -->
      <div class="services-details-img d-flex gap-3 mb-4 flex-wrap justify-content-end">
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/ser4.jpg"
          alt="Event Banner 1"
          class="top-banner-img"
        />
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/sera1.jpg"
          alt="Event Banner 2"
          class="top-banner-img"
        />
      </div>

      <div class="row">
        <div class="col-lg-8">
          <div class="services-details-content">
            <h2>Events & Inaugurations</h2>

            <h3  title="We connect brands with celebrities and influencers for powerful digital campaigns.">Make Your Brand’s Big Day Unforgettable — With Stars, Stories, and Spotlight.</h3>
            <p>
              At <strong>MyCelebrity by Digitalentio</strong>, we specialize in organizing grand events that leave a lasting impression...
            </p>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">What We Offer:</h3>
            <ul>
              <li><strong>Celebrity Appearances & Chief Guests</strong> — We bring regional and national celebrities...</li>
              <li><strong>Store & Showroom Inaugurations</strong> — From ribbon cutting to red carpet...</li>
              <li><strong>Concept Planning & Thematic Decor</strong> — Custom event themes...</li>
              <li><strong>Anchor / Event Host Management</strong> — Professional anchors in multiple languages...</li>
              <li><strong>Photography & Videography</strong> — Live coverage, aftermovies, and more...</li>
              <li><strong>PR & Media Coverage</strong> — Get featured in top media houses...</li>
              <li><strong>Complete On-Ground Execution</strong> — From logistics to crowd control...</li>
            </ul>

            <div class="mb-lg-5 mb-4"></div>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Events We’ve Powered:</h3>
            <ul>
              <li><strong>Intralife Pharmaceuticals – 44th Anniversary</strong> — Featuring Real Star Upendra & Sharanya Shetty.</li>
              <li><strong>Jos Alukkas Launch</strong> — With Keerthi Suresh and Aishwarya Rajesh.</li>
              <li><strong>PMJ Jewels Launch</strong> — Celebrity Bhavya Gowda joined by top host.</li>
              <li><strong>Lulu Mall Openings</strong> — Celebrities, décor, and stage performances.</li>
              <li><strong>Everest Masala, Sunpure Events</strong> — Chef shows and influencer meets.</li>
            </ul>

            <div class="mb-lg-5 mb-4"></div>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Why Choose Us?</h3>
            <ul>
              <li>Vast celebrity and influencer network</li>
              <li>Top anchors & hosts (regional & national)</li>
              <li>Expert event production team</li>
              <li>Turnkey event solutions across South India</li>
            </ul>
          </div>
        </div>

        <div class="col-lg-4 mt-4 mt-lg-0">
          <ServicesSidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServicesSidebar from "@/components/ServiceDetails/ServivesSidebar.vue";

export default {
  name: "ServicesDetails",
  components: {
    ServicesSidebar,
  },
};
</script>

<style lang="scss" scoped>
// Light Mode
:deep(body):not(.theme-dark) {
  .services-details-bg {
    background-color: #fff;
    color: #000;
  }
}

// Dark Mode
:deep(body.theme-dark) {
  .services-details-bg {
    background-color: #111;
    color: #fff;
  }
}

.services-details-bg {
  padding-top: 180px;
  padding-bottom: 100px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.services-details-img {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: flex-end;

  .top-banner-img {
    width: 48%;
    max-width: 100%;
    max-height: 400px;
    object-fit: cover;
    border-radius: 20px;
    display: block;
  }
}

.services-details-content {
  padding-top: 20px;

  h2 {
    font-size: 36px;
    margin-bottom: 25px;
  }

  h3 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
  }

  h4 {
    font-size: 18px;
    font-weight: 600;
    margin-top: 25px;
    margin-bottom: 10px;
  }

  ul {
    padding-left: 1.2rem;
    margin-bottom: 20px;

    li {
      margin-bottom: 10px;
    }
  }
}

/* Responsive Design */
@media only screen and (max-width: 767px) {
  .services-details-img {
    flex-direction: column;
    align-items: center;

    .top-banner-img {
      width: 100%;
      max-height: 220px;
    }
  }

  .services-details-content h2 {
    font-size: 25px;
    margin-bottom: 15px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .services-details-img .top-banner-img {
    max-height: 300px;
  }

  .services-details-content h2 {
    font-size: 30px;
    margin-bottom: 15px;
  }
}
</style>
